import { render } from "./EnrolmentFailure.vue?vue&type=template&id=62d57a7d"
import script from "./EnrolmentFailure.vue?vue&type=script&lang=js"
export * from "./EnrolmentFailure.vue?vue&type=script&lang=js"

import "./EnrolmentFailure.vue?vue&type=style&index=0&id=62d57a7d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__